import {
  deleteCall,
  postCall,
  getCall,
  putCall,
  patchCall,
  HeadersInterface,
  BodyParamsInterface,
  convertInterfaceToBodyParams,
  QueryParamsInterface,
} from "./api";

const BASE_URL = "v1/public";

export const getLastShirts = async (count: number) => {
  let url = BASE_URL + "/lastItems";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, "item_count=" + count);

  return response.data;
};
